import { render, staticRenderFns } from "./operateNormalOn.vue?vue&type=template&id=bae88a9c&"
import script from "./operateNormalOn.vue?vue&type=script&lang=ts&"
export * from "./operateNormalOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports